import DemandeInscription from "../views/DemandeInscription.vue"
import RenseignementsGeneraux from "../components/DemandeInscriptionInitiale/RenseignementsGeneraux.vue"
import AutorisationDePratique from "../components/DemandeInscriptionInitiale/AutorisationDePratique.vue"
import DeclarationsObligatoires from "../components/DemandeInscriptionInitiale/DeclarationsObligatoires.vue"
import AttestationVeracite from "../components/DemandeInscriptionInitiale/AttestationVeracite.vue"
import TransmissionOrdre from "../components/DemandeInscriptionInitiale/TransmissionOrdre.vue"
import StatutEmploiEtLieuxDeTravail from "../components/DemandeInscriptionInitiale/StatutEmploiEtLieuxDeTravail"
import Assurance from "../components/DemandeInscriptionInitiale/Assurance"
import ActiviteReservee from "../components/DemandeInscriptionInitiale/ActiviteReservee"
import RecapitulatifPaiement from "../components/DemandeInscriptionInitiale/RecapitulatifPaiement.vue"

const routeName = "DemandeInscriptionInitiale"

export default [
  {
    path: "/demande-inscription/premiere",
    name: "DemandeInscriptionInitiale",
    component: DemandeInscription,
    meta: {
      title: "Demande inscription | OTSTCFQ",
    },
    props: {
      routeName: routeName,
    },
    children: [
      {
        path: "renseignements-generaux",
        name: `${routeName}/RenseignementsGeneraux`,
        component: RenseignementsGeneraux,
      },
      {
        path: "autorisation-de-pratique",
        name: `${routeName}/AutorisationDePratique`,
        component: AutorisationDePratique,
      },
      {
        path: "statut-emploi-et-lieux-de-travail",
        name: `${routeName}/StatutEmploiEtLieuxDeTravail`,
        component: StatutEmploiEtLieuxDeTravail,
      },
      {
        path: "activite-reservee",
        name: `${routeName}/ActiviteReservee`,
        component: ActiviteReservee,
      },
      {
        path: "assurance",
        name: `${routeName}/Assurance`,
        component: Assurance,
      },
      {
        path: "declarations-obligatoires",
        name: `${routeName}/DeclarationsObligatoires`,
        component: DeclarationsObligatoires,
      },
      {
        path: "transmission-ordre",
        name: `${routeName}/TransmissionOrdre`,
        component: TransmissionOrdre,
      },
      {
        path: "recapitulatif-paiement",
        name: `${routeName}/RecapitulatifPaiement`,
        component: RecapitulatifPaiement,
      },
      {
        path: "attestation-veracite",
        name: `${routeName}/AttestationVeracite`,
        component: AttestationVeracite,
      },
    ],
  },
]
